import { Store } from '@oneaudi/audi-myaudi-utils-feature-app';

export class I18n extends Store.AbstractI18nStore {
  public closeButton = (): string => this.translate(`notificationfeatureapp.popup.close`);
}
